module.exports = __webpack_public_path__ + "img/icon_newsds_bg.048b14a3.png";